// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import React from 'react';
import PropTypes from 'prop-types';
import { Box, useFormContext } from '@metarouter-private/mr-mui';

import PipelineForm from '../PipelineForm';

/**
 * The expandableRowsComponent for the confirm-update data-table. RDT only mounts
 * it when its row is expanded and passes the row object as `{ data }`, so it just
 * adapts that row shape onto the existing PipelineForm with isExpanded hard-set to
 * true (RDT owns the expand/collapse state). Thin glue — no new state or
 * validation; values flow through the surrounding RHF FormProvider.
 */
export default function PipelineFormPanel({ data }) {
  const { getValues } = useFormContext();

  // Default the consent fields to the LIVE form value rather than the row
  // snapshot: mr-mui's FormSelect resetFields to its defaultValue on mount, which
  // would otherwise clobber a category bulk-applied while this row was collapsed.
  // Fall back to the snapshot when consent isn't seeded into the form.
  const currentValues = getValues(data.pipeline.id) || {};
  const currentConsentCategoryId = currentValues.consentCategoryId ?? data.currentConsentCategoryId;
  const currentConsentMode = currentValues.consentMode ?? data.currentConsentMode;

  return (
    <Box data-test-id={`pipelineFormPanel-${data.pipeline.id}`}>
      <PipelineForm
        pipelineId={data.pipeline.id}
        pipelineVariables={data.pipelineVariables}
        currentConsentCategoryId={currentConsentCategoryId}
        currentConsentMode={currentConsentMode}
        isExpanded
      />
    </Box>
  );
}

PipelineFormPanel.propTypes = {
  data: PropTypes.shape({
    pipeline: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
    pipelineVariables: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        currentValue: PropTypes.string,
      })
    ).isRequired,
    currentConsentCategoryId: PropTypes.string,
    currentConsentMode: PropTypes.string,
  }).isRequired,
};
